import { simplePath } from 'ze-api-contract/utils';
import { RouteNames } from './route-names';
const org_cache = new Map();
function cache_org(path, param) {
    let { organization, query, token } = param;
    const value = organization === null || organization === void 0 ? void 0 : organization.name;
    const tokenValue = token === null || token === void 0 ? void 0 : token.name;
    if (!value) return '/';
    const cache_key = "".concat(path, ":").concat(value, ":").concat(query !== null && query !== void 0 ? query : '', ":").concat(tokenValue !== null && tokenValue !== void 0 ? tokenValue : '');
    if (org_cache.has(cache_key)) {
        var _org_cache_get;
        return (_org_cache_get = org_cache.get(cache_key)) !== null && _org_cache_get !== void 0 ? _org_cache_get : '/';
    }
    const url = simplePath(path, {
        organization: value,
        token: tokenValue
    }) + (query !== null && query !== void 0 ? query : '');
    org_cache.set(cache_key, url);
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_path(props) {
    return cache_org(RouteNames.ORGANIZATION, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/projects"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_projects_path(props) {
    return cache_org(RouteNames.ORGANIZATION_PROJECTS, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/managed-applications"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_managed_applications_path(props) {
    return cache_org(RouteNames.ORGANIZATION_MANAGED_APPLICATIONS, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/unmanaged-applications"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_unmanaged_applications_path(props) {
    return cache_org(RouteNames.ORGANIZATION_UNMANAGED_APPLICATIONS, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/unmanaged-applications/new"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_unmanaged_application_new_path(props) {
    return cache_org(RouteNames.ORGANIZATION_UNMANAGED_APPLICATION_NEW, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/unmanaged-applications/$application/edit"
 *   params={{ organization: 'org-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_unmanaged_application_edit_path(param) {
    let { organization, application } = param;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !application.name) {
        return '/';
    }
    const url = simplePath(RouteNames.ORGANIZATION_UNMANAGED_APPLICATION_EDIT, {
        organization: organization.name,
        application: application.name
    });
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/teams"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_team_list_path(props) {
    return cache_org(RouteNames.ORGANIZATION_TEAM_LIST, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/teams/$team"
 *   params={{ organization: 'org-name', team: 'team-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_team_path(param) {
    let { organization, team, query } = param;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !team.name) {
        return '/';
    }
    const url = simplePath(RouteNames.ORGANIZATION_TEAM, {
        organization: organization.name,
        team: team.name
    });
    return url + (query !== null && query !== void 0 ? query : '');
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/people"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_people_path(props) {
    return cache_org(RouteNames.ORGANIZATION_PEOPLE, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/settings"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_settings_path(props) {
    return cache_org(RouteNames.ORGANIZATION_SETTINGS, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/membership"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_membership_path(props) {
    return cache_org(RouteNames.ORGANIZATION_MEMBERSHIP, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/settings/payment-methods"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_settings_payment_methods_path(props) {
    return cache_org(RouteNames.ORGANIZATION_PAYMENT_METHODS, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/settings/billing-history"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_settings_billing_history_path(props) {
    return cache_org(RouteNames.ORGANIZATION_BILLING_HISTORY, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/subscription"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_subscription_path(props) {
    return cache_org(RouteNames.ORGANIZATION_SUBSCRIPTION, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/subscription/manage"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_subscription_manage_path(props) {
    return cache_org(RouteNames.ORGANIZATION_SUBSCRIPTION_MANAGE, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/deployment-integrations"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_deployment_integrations_list_path(props) {
    return cache_org(RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION_LIST, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/deployment-integrations/$integrationType"
 *   params={{ organization: 'org-name', integrationType: 'type-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_deployment_integrations_path(param) {
    let { organization, type } = param;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !type.name) {
        return '/';
    }
    const url = simplePath(RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION_OVERVIEW, {
        organization: organization.name,
        integrationType: type.name
    });
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/deployment-integrations/$integrationType/new"
 *   params={{ organization: 'org-name', integrationType: 'type-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_deployment_integrations_new_path(param) {
    let { organization, type } = param;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !type.name) {
        return '/';
    }
    const url = simplePath(RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION_ADD, {
        organization: organization.name,
        integrationType: type.name
    });
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/deployment-integrations/$integrationType/$integrationName"
 *   params={{ organization: 'org-name', integrationType: 'type-name', integrationName: 'name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_deployment_integrations_name_path(param) {
    let { organization, type, name } = param;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !type.name || !name.name) {
        return '/';
    }
    const url = simplePath(RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION, {
        organization: organization.name,
        integrationType: type.name,
        integrationName: name.name
    });
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/deployment-integrations/$integrationType/$integrationName/edit"
 *   params={{ organization: 'org-name', integrationType: 'type-name', integrationName: 'name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_deployment_integrations_edit_path(param) {
    let { organization, type, name } = param;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !type.name || !name.name) {
        return '/';
    }
    const url = simplePath(RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION_EDIT, {
        organization: organization.name,
        integrationType: type.name,
        integrationName: name.name
    });
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/settings/server-tokens/new"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_settings_server_token_new_path(props) {
    const settingsPath = RouteNames.ORGANIZATION_SETTINGS;
    const path = "".concat(settingsPath, "/").concat(RouteNames.ORGANIZATION_SERVER_TOKEN_NEW);
    return cache_org(path, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/settings/server-tokens"
 *   params={{ organization: 'org-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function organization_settings_server_tokens_path(props) {
    const settingsPath = RouteNames.ORGANIZATION_SETTINGS;
    const path = "".concat(settingsPath, "/").concat(RouteNames.ORGANIZATION_SERVER_TOKENS);
    return cache_org(path, props);
}
export function organization_settings_server_token_path(props) {
    const settingsPath = RouteNames.ORGANIZATION_SETTINGS;
    // const tokenPath = cache_org(RouteNames.ORGANIZATION_SERVER_TOKEN_EDIT, props);
    const path = "".concat(settingsPath, "/").concat(RouteNames.ORGANIZATION_SERVER_TOKEN_EDIT);
    return cache_org(path, props);
}
